// 标准代码工具类

// ----------------------------------- 性别 ----------------------------------
const Company = {}

Company.dict = [
  {
    code: 'signet',
    enName: 'Signet',
    twName: 'Signet'
  },
  {
    code: 'supera',
    enName: 'Supera',
    twName: 'Supera'
  }
]

Company.getByCode = (code) => {
  const matched = Company.dict.filter(item => {
    return item.code == code
  })
  if (matched && matched.length > 0) {
    return matched[0]
  } else {
    return null
  }
}

// ----------------------------------- 与本人的关系 ----------------------------------
const RealationShip = {}

RealationShip.dict = [
  {
    code: 'A',
    enName: 'Relatives',
    twName: 'Relatives'
  },
  {
    code: 'B',
    enName: 'Friends',
    twName: 'Friends'
  },
  {
    code: 'C',
    enName: 'Colleague',
    twName: 'Colleague'
  },
  {
    code: 'Z',
    enName: 'Unknown',
    twName: 'Unknown'
  }
]

RealationShip.getByCode = (code) => {
  const matched = RealationShip.dict.filter(item => {
    return item.code == code
  })
  if (matched && matched.length > 0) {
    return matched[0]
  } else {
    return null
  }
}


// ----------------------------------- PassportTravelDocType ----------------------------------
const PassportTravelDocType = {}

PassportTravelDocType.dict = [
  {
    code: '1',
    countryCode: 'USA',
    enName: 'USA',
    twName: 'USA'
  },
  {
    code: '2',
    countryCode: 'USA',
    enName: 'USA(Re-entry permit)',
    twName: 'USA(Re-entry permit)'
  },
  {
    code: '3',
    countryCode: 'CAN',
    enName: 'Canada',
    twName: 'Canada'
  },
  {
    code: '4',
    countryCode: 'TWN',
    enName: 'Taiwan',
    twName: 'Taiwan'
  },
  {
    code: '5',
    countryCode: 'TWN',
    enName: 'Taiwan(Mainland Travel Permit)',
    twName: 'Taiwan(Mainland Travel Permit)'
  },
  {
    code: '6',
    countryCode: 'HKG',
    enName: 'Hong Kong',
    twName: 'Hong Kong'
  },
  {
    code: '7',
    countryCode: 'HKG',
    enName: 'Hong Kong(Mainland Travel Permit)',
    twName: 'Hong Kong(Mainland Travel Permit)'
  },
  {
    code: '8',
    countryCode: 'HKG',
    enName: 'Hong Kong(Exit & Entry Permit for Taiwan)',
    twName: 'Hong Kong(Exit & Entry Permit for Taiwan)'
  },
  {
    code: '9',
    countryCode: 'MAC',
    enName: 'Macao',
    twName: 'Macao'
  },
  {
    code: '10',
    countryCode: 'MAC',
    enName: 'Macao(Mainland Travel Permit)',
    twName: 'Macao(Mainland Travel Permit)'
  },
  {
    code: '11',
    countryCode: 'MAC',
    enName: 'Macao(Exit & Entry Permit for Taiwan)',
    twName: 'Macao(Exit & Entry Permit for Taiwan)'
  },
  {
    code: '12',
    countryCode: 'CHN',
    enName: 'China',
    twName: 'China'
  },
  {
    code: '13',
    countryCode: 'CHN',
    enName: 'China(Travel permit to & from Taiwan)',
    twName: 'China(Travel permit to & from Taiwan)'
  },
  {
    code: '14',
    countryCode: 'CHN',
    enName: 'China(Resident Identity Card)',
    twName: 'China(Resident Identity Card)'
  },
  {
    code: '15',
    countryCode: 'JPN',
    enName: 'Japan',
    twName: 'Japan'
  },
  {
    code: '16',
    countryCode: 'VNM',
    enName: 'Viet Nam',
    twName: 'Viet Nam'
  },
  {
    code: '17',
    countryCode: 'THA',
    enName: 'Thailand',
    twName: 'Thailand'
  },
  {
    code: '18',
    countryCode: 'SGP',
    enName: 'Singapore',
    twName: 'Singapore'
  },
  {
    code: '19',
    countryCode: 'AUS',
    enName: 'Australia',
    twName: 'Australia'
  },
  {
    code: '20',
    countryCode: 'CHE',
    enName: 'Switzerland',
    twName: 'Switzerland'
 },
 {
  code: '21',
  countryCode: 'GBR',
  enName: 'British',
  twName: 'British'
}
]

PassportTravelDocType.getByCode = (code) => {
  const matched = PassportTravelDocType.dict.filter(item => {
    return item.code == code
  })
  if (matched && matched.length > 0) {
    return matched[0]
  } else {
    return null
  }
}

// ----------------------------------- 护照类型 11----------------------------------
const PassportType = {}

PassportType.dict = [
  {
    code: 'A',
    enName: 'Passport',
    twName: 'Passport'
  },
  {
    code: 'B',
    enName: '港澳通行證',
    twName: '港澳通行證'
  }
  ,
  {
    code: 'C',
    enName: '台胞證',
    twName: '台胞證'
  }
]

PassportType.getByCode = (code) => {
const matched = PassportType.dict.filter(item => {
    return item.code == code
  })
  if (matched && matched.length > 0) {
    return matched[0]
  } else {
    return null
  }
}

// ----------------------------------- 称呼或职业 ----------------------------------
const Title = {}

Title.dict = [
  {
    code: '1',
    enName: 'Mr.',
    twName: 'Mr.'
  },
  {
    code: '2',
    enName: 'Mrs.',
    twName: 'Mrs.'
  },
  {
    code: '3',
    enName: 'Ms.',
    twName: 'Ms.'
  },
  {
    code: '4',
    enName: 'Miss',
    twName: 'Miss'
  },
  {
    code: '5',
    enName: 'Mstr.',
    twName: 'Mstr.'
  },
  {
    code: '6',
    enName: 'Dr.',
    twName: 'Dr.'
  },
  {
    code: '7',
    enName: 'Prof.',
    twName: 'Prof.'
  }
  
]

Title.getByCode = (code) => {
  const matched = Title.dict.filter(item => {
    return item.code == code
  })
  if (matched && matched.length > 0) {
    return matched[0]
  } else {
    return null
  }
}

// ----------------------------------- 性别 ----------------------------------
const Gender = {}

Gender.dict = [
  {
    code: 'M',
    enName: 'M',
    twName: '男'
  },
  {
    code: 'F',
    enName: 'F',
    twName: '女'
  }
]

Gender.getByCode = (code) => {
const matched = Gender.dict.filter(item => {
    return item.code == code
  })
  if (matched && matched.length > 0) {
    return matched[0]
  } else {
    return null
  }
}

export {
  Gender,
  Title,
  PassportType,
  RealationShip,
  Company,
  PassportTravelDocType
}
